export { SectionHeader, type SectionHeaderProps } from './SectionHeader';
export {
  sectionHeaderVariants,
  type SectionHeaderVariantProps,
} from './section-header.variants';
export type {
  ActionButtonConfig,
  ButtonConfig,
  SectionHeaderIconProps,
} from './SectionHeader';
